/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import Text from './Text';

import styles from '../../../styles/partials/links.scss';

const isSocial = url => url.match(/(facebook\.com|vimeo\.com|twitter\.com|instagram\.com)/i) !== null;
const isBaseUrl = url => url.replace(/[/?#]+$/gi, '').match(/\.([a-z]+)$/) !== null;
const getDomain = url => url.replace(/[/?#]+$/gi, '').match(/^(https?:\/\/)?(.*)$/)[2];

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
    })).isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Links = ({ items, className }) => {
    const otherLinks = items.filter(({ url }) => !isSocial(url));
    const socialLinks = items.filter(({ url }) => isSocial(url));
    return (
        <div
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            {otherLinks.length > 0 ? (
                <ul className={styles.links}>
                    {otherLinks.map(it => (
                        <li key={`link-social-${it.url}`} className={styles.item}>
                            <a href={it.url} className={styles.link} target="_blank" title={it.label}>
                                {isBaseUrl(it.url) ? (
                                    getDomain(it.url)
                                ) : (
                                    <Text inline>{ it.label }</Text>
                                )}
                            </a>
                        </li>
                    ))}
                </ul>
            ) : null}
            {socialLinks.length > 0 ? (
                <ul className={styles.social}>
                    {socialLinks.map(it => (
                        <li key={`link-social-${it.url}`} className={styles.item}>
                            <a href={it.url} className={styles.link} target="_blank" title={it.label}>
                                <span
                                    className={classNames({
                                        [styles.icon]: true,
                                        [styles[
                                            get(
                                                it.url.match(/(facebook|vimeo|twitter|instagram)/i),
                                                '1',
                                                '',
                                            ).toLowerCase()
                                        ]]: true,
                                    })}
                                />
                            </a>
                        </li>
                    ))}
                </ul>
            ) : null}
        </div>
    );
};

Links.propTypes = propTypes;
Links.defaultProps = defaultProps;

export default Links;



// WEBPACK FOOTER //
// ./js/components/partials/Links.jsx